export default __webpack_public_path__ + "static/media/brakes_icon.7859a56b.svg";